import { Box, Typography, Button, Paper } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useNavigate, useSearchParams } from 'react-router-dom';

export const SubscriptionSuccess: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const planName = searchParams.get('plan') || '';
  const isRenewal = searchParams.get('renewal') === 'true';

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      bgcolor="background.default"
      padding={3}
    >
      <Paper
        sx={{
          p: 6,
          maxWidth: 500,
          textAlign: 'center',
          borderRadius: 3,
        }}
      >
        <CheckCircleOutlineIcon color="success" sx={{ fontSize: 80, mb: 2 }} />
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Assinatura Confirmada!
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 1 }}>
          {planName
            ? `Sua assinatura do plano ${planName} foi confirmada com sucesso.`
            : 'Sua assinatura foi confirmada com sucesso.'}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
          {isRenewal
            ? 'Seu plano foi renovado e você já pode acessar todas as funcionalidades.'
            : 'Você já pode acessar todas as funcionalidades do seu plano.'}
        </Typography>
        <Box display="flex" flexDirection="column" gap={2}>
          <Button
            variant="contained"
            size="large"
            onClick={() => navigate('/onboarding')}
            sx={{ borderRadius: 2, py: 1.5 }}
          >
            Ir para o painel
          </Button>
          <Button
            variant="outlined"
            onClick={() => navigate('/business')}
            sx={{ borderRadius: 2 }}
          >
            Gerenciar estabelecimento
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};
